import type { FaireProductEntity } from "../../entity_types/product";

export const p_7kdbzz3rsz: FaireProductEntity = {
  token: "p_7kdbzz3rsz",
  type: "product",
  name: "Cold & Sinus Salve – Camphor-Free Natural Vapor Rub",
  brandToken: "b_129dsr49u5",
  brandName: "Taylor Made Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/249ade8bf4ee711aeb70aad1f0e45ce47743027d88985957d6daf90d1e35a69b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4147b4daa63721935d957a6430b1dd9a664cac68cd979ee50c76554b8be54738.png",
    "https://cdn.faire.com/fastly/2d7561e69dbe39467f010a05446c0573e1203dd816b17cceda4e953a3c24e9da.png",
    "https://cdn.faire.com/fastly/7427c35ba95ae4e00b9550f63de0c48cb76a74494a510a2d69fef199b8a90e71.png",
    "https://cdn.faire.com/fastly/f6854761594dcc486821997828535b88cf8a04c627253c162dadf4a2af25b27e.png",
    "https://cdn.faire.com/fastly/8cf3f3ea0378f0ea384bc0a0f59dada7ea3aaf54e04437fcf5756e77ef7b0007.png",
  ],
  priceDollars: 11.5,
  description:
    "Natural cold & sinus relief salve with peppermint, spearmint & eucalyptus. Camphor-free, kid-safe, and made with organic ingredients in the USA.\n\nSoothe congestion and breathe easier with our Cold & Sinus Salve, a clean, camphor-free alternative to vapor rubs. Infused with a therapeutic blend of peppermint, spearmint, eucalyptus, and rosemary essential oils, this gentle balm helps ease sinus pressure, headaches, and cold symptoms—naturally.\n\nSafe for infants, children, and adults\nCamphor-free, petroleum-free formula\nOrganic sunflower oil, shea butter & cocoa butter nourish skin\nBeeswax base locks in moisture & creates a protective barrier\n\nFree of parabens, glycol, and phthalates\nMade in the USA | Small-batch crafted\n\nPackaged in a 2 oz stainless steel tin\n\nHow to use: Apply a small amount under the nose, on the chest, or on cheekbones as needed for soothing relief.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:39.266Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
